// Nuestros Servicios
import TL_React from "../assets/technologies-logo/reactjs.png";
import TL_Angular from "../assets/technologies-logo/angularjs.png";
import TL_Node from "../assets/technologies-logo/nodejs.png";
import TL_Python from "../assets/technologies-logo/python.png";
import TL_Android from "../assets/technologies-logo/android.png";
import TL_Kotlin from "../assets/technologies-logo/kotlin.png";
import TL_IOS from "../assets/technologies-logo/iOS.png";
import TL_Swift from "../assets/technologies-logo/swift.png";
import TL_JS from "../assets/technologies-logo/javascript.png";
import TL_CSharp from "../assets/technologies-logo/c#.png";
import TL_UiPath from "../assets/technologies-logo/uipath.png";
import TL_BluePrism from "../assets/technologies-logo/blueprism.png";
import TL_AutoAny from "../assets/technologies-logo/automation-anywhere.png";
import TL_AWS from "../assets/technologies-logo/aws.png";
import TL_Azure from "../assets/technologies-logo/azure.png";
import TL_GCloud from "../assets/technologies-logo/googlecloud.png";

import CardIconWeb from "../assets/service-card-icons/v1_web_design.png";
import CardIconApp from "../assets/service-card-icons/v1_app_dev.png";
import CardIconIoT from "../assets/service-card-icons/v1_internet_of_things.png";
import CardIconAuto from "../assets/service-card-icons/v1_automation.png";
import CardIconCloud from "../assets/service-card-icons/v1_cloud.png";
import CardIconConsult from "../assets/service-card-icons/v1_consultory.png";

// Multiples industrias
import IconEnergy from "../assets/industries-icons/energy-icon-solid.png";
import IconBank from "../assets/industries-icons/bank-icon-solid.png";
import IconConstruction from "../assets/industries-icons/construction-icon-solid.png";
import IconConsulting from "../assets/industries-icons/consulting-icon-solid.png";
import IconFinance from "../assets/industries-icons/finance-icon-solid.png";
import IconHS from "../assets/industries-icons/hardware-software-icon-solid.png";
import IconInsurance from "../assets/industries-icons/insurance-icon-solid.png";
import IconMassiveGoods from "../assets/industries-icons/massive-goods-icon-solid.png";
import IconRealState from "../assets/industries-icons/real-state-icon-solid.png";
import IconRetail from "../assets/industries-icons/retail-icon-solid.png";
import IconTelecomm from "../assets/industries-icons/telecomm-icon-solid.png";
import IconStockMarket from "../assets/industries-icons/stock-market-icon-solid.png";

// flags
import mexicoFlag from "../assets/flags/mexico-flag-48.png";
import USAFlag from "../assets/flags/ee-uu-flag-48.png";

export const textlanguages = [
  // SPANISH
  {
    header: [
      { service: "SERVICIOS", path: "services" },
      { service: "INDUSTRIAS", path: "industries" },
      { service: "PORTAFOLIO", path: "portfolio" },
      { service: "NOSOTROS", path: "about-us" },
      { service: "CONTACTO", path: "contact" },
    ],
    mainPage: {
      sectionOne: {
        title: "El partner de tecnología",
        titleSecondRow: "que buscabas",
      },
    },
    ourServices: {
      title: "Nuestros Servicios",
      description:
        "Contamos con una amplia gama de servicios diseñados para satisfacer las necesidades tecnológicas de tu empresa, centrándonos en soluciones innovadoras, eficientes y a la medida que nos conviertan en tu socio de tecnología ideal.",
      tecnologyCards: [
        // webApps
        {
          icon: CardIconWeb,
          title: "Diseño y Desarrollo Web",
          description:
            "Somos expertos en la creación de plataformas intuitivas y responsivas, transformando tus ideas en sitios web impactantes y eficientes.",
          tecnologies: [
            { name: "AngularJS", icon: TL_Angular },
            { name: "ReactJS", icon: TL_React },
            { name: "NodeJS", icon: TL_Node },
          ],
        },
        // movile
        {
          icon: CardIconApp,
          title: "Aplicaciones Móviles",
          description:
            "Desarrollamos aplicaciones móviles a medida, combinando innovación y funcionalidad garantizando una experiencia de usuario excepcional.",
          tecnologies: [
            { name: "Kotlin", icon: TL_Kotlin },
            { name: "Android", icon: TL_Android },
            { name: "iOS", icon: TL_IOS },
            { name: "Swift", icon: TL_Swift },
          ],
        },
        // iot
        {
          icon: CardIconIoT,
          title: "IoT | Internet de las Cosas",
          description:
            "Lideramos la revolución IoT, integrando con eficiencia y seguridad dispositivos inteligentes que mejoran la vida cotidiana y los negocios.",
          tecnologies: [
            { name: "Python", icon: TL_Python },
            { name: "Javascript", icon: TL_JS },
            { name: "C#", icon: TL_CSharp },
          ],
        },
        // automation
        {
          icon: CardIconAuto,
          title: "Automatización de Procesos",
          description:
            "Optimizamos tus operaciones empresariales, reduciendo tiempos y maximizando resultados. Eleva tu productividad con nuestras estrategias y soluciones.",
          tecnologies: [
            { name: "Javascript", icon: TL_JS },
            { name: "UiPath", icon: TL_UiPath },
            { name: "Blue Prism", icon: TL_BluePrism },
            { name: "Automation Anywhere", icon: TL_AutoAny },
          ],
        },
        // cloudServices
        {
          icon: CardIconCloud,
          title: "Arquitectura y Servicios Cloud",
          description:
            "Ofrecemos soluciones en la nube, seguras, escalables y adaptadas a tus necesidades específicas para impulsar la transformación digital de tu empresa.",
          tecnologies: [
            { name: "Amazon Web Services", icon: TL_AWS },
            { name: "Microsoft Azure", icon: TL_Azure },
            { name: "Google Clod", icon: TL_GCloud },
          ],
        },
        // consultancy
        {
          icon: CardIconConsult,
          title: "Consultoría Tecnológica",
          description:
            "Nuestro equipo de expertos brinda asesoramiento tecnológico estratégico, ayudándote a navegar con confianza en el cambiante paisaje digital.",
          tecnologies: [],
        },
      ],
    },
    Industries: {
      title: "Múltiples Industrias",
      description:
        "Hemos tenido la oportunidad de participar activamente en diversos proyectos que abarcan un amplio número de industrias y sectores que se encuentran en diferentes facetas tecnológicas.",
      typeOfIndustries: [
        {
          icon: IconEnergy,
          title: "Energía",
        },
        {
          icon: IconTelecomm,
          title: "Telecomunicaciones",
        },
        {
          icon: IconRetail,
          title: "Retail",
        },
        {
          icon: IconMassiveGoods,
          title: "Consumo Masivo",
        },
        {
          icon: IconConstruction,
          title: "Construcción",
        },
        {
          icon: IconBank,
          title: "Banca",
        },
        {
          icon: IconFinance,
          title: "Finanzas y Contabilidad",
        },
        {
          icon: IconStockMarket,
          title: "Mercado de Capitales",
        },
        {
          icon: IconInsurance,
          title: "Seguros",
        },
        {
          icon: IconRealState,
          title: "Inmobiliario",
        },
        {
          icon: IconConsulting,
          title: "Consultoría y Asesoría",
        },
        {
          icon: IconHS,
          title: "Hardware y Software",
        },
      ],
    },
    portfolio: {
      title: "Casos de Éxito",
      description:
        "Al igual que nuestros clientes, tenemos un deseo vehemente de hacer realidad grandes proyectos tecnológicos. Explore cómo hemos colaborado con líderes de la industria para crear soluciones impactantes y eficientes.",
      filterButton: "Buscar",
      labelFilterIndustry: "Industria",
      inputLabelIndustry: "Selecciona una industria",
      labelFilterCompany: "Empresas",
      inputFilterCompany: "Selecciona una empresa",
      titleProject: "Proyectos de",
      projectInformationCard: {
        client: "Cliente",
        Industry: "Industria",
        Service: "Servicios",
      },
    },
    aboutUs: {
      title: "¿Por qué GREEDY?",
      description:
        "Somos optimistas por naturaleza, por lo que creemos firmemente en el lado bueno de las cosas. Sabemos que nuestros clientes tienen el afán desmedido y deseo vehemente de convertir en realidad sus ideas y proyectos tecnológicos por lo que merecen un socio tecnológico que tenga el mismo afán y deseo por cumplir sus expectativas.",
    },
    contact: {
      title: "¡Seamos Partners!",
      description:
        "Estamos muy emocionados en hacer equipo contigo y convertir en realidad tu visión de negocio. Nos puedes contactar a través del siguiente formulario o con los siguientes datos:",
      nameField: "Nombre",
      emailField: "Correo Electrónico",
      companyField: "Compañía",
      phoneField: "Teléfono",
      messageFiled: "Cuéntanos tu idea/proyecto",
      emailInfo: "Correo Electrónico:",
      phoneInfo: "Teléfono de Contacto:",
      addressInfo: "Dirección:",
      ButtonSend: "Enviar",
    },
    legal: {
      terms: {
        title: "Términos y Condiciones",
        description: [
          "Al navegar en",
          "https://greedy.mx/",
          "usted está consintiendo sus términos de uso. Si no está de acuerdo con ellos, deberá abstenerse de usar este sitio.",
        ],
        sections: [
          {
            header: "Uso y restricciones del contenido",
            paragraphs: [
              "El propósito de este sitio es dar a conocer a Greedy y los servicios que ofrece. Además, ponemos a su disposición un formulario de contacto para conocerlo a usted y a su visión de negocio con el fin de convertirnos en partners y así trabajar juntos en sus ideas y proyectos tecnológicos.",
              "Salvo que se indique lo contrario, usted está autorizado para ver, copiar, imprimir y distribuir los contenidos de este sitio web, bajo las siguientes condiciones:",
            ],
            list: [
              "El uso sea con fines legales y legítimos acorde a este término y a la normatividad aplicable.",
              "Dicho uso sea exclusivamente para fines informativos y no comerciales.",
              "El contenido no sea modificado.",
              "Cualquier copia del contenido que usted haga debe atribuir los derechos de autor correspondientes u otra atribución asociada con el mismo.",
            ],
            paragraphsAfterList: [
              "Usted no está autorizado a copiar o utilizar cualquier software, proceso o tecnología incorporada o descrita en este sitio web.",
              "Usted deberá cumplir con todas las leyes aplicables respecto al acceso y uso de este sitio web.",
            ],
          },
          {
            header: "Política de privacidad",
            paragraphs: [
              "Greedy está comprometido con la protección de sus datos personales, por lo tanto, ponemos a su disposición nuestro Aviso de Privacidad y nuestra Política de Cookies, ambos disponibles en este sitio web. Estos documentos explican el uso que hacemos de tecnologías de rastreo como cookies, incluyendo herramientas de terceros como Google Ads. que podrá encontrar en este sitio web. Hacemos de su conocimiento que podemos utilizar sus datos e información personal en los términos que señalan. Usted acepta, por medio de la presente, los términos de nuestro Aviso de Privacidad, incluyendo las obligaciones contenidas en dichos avisos.",
            ],
          },
          {
            header: "Confidencialidad",
            paragraphs: [
              "El contenido de este sitio web es propiedad de Greedy y reservamos todos los derechos no concedidos expresamente en estos términos y condiciones de uso. Usted no podrá hacer uso del nombre de Greedy ni su logo, marca o signos distintivos en cualquier material propio o promocional; ya sea en forma escrita, oral, electrónica, visual o cualquier otro, con excepción de que le haya sido expresamente permitido.",
              "Para solicitar dicha autorización por escrito, contáctenos al correo",
              "Las referencias a marcas comerciales de terceros en este sitio web son meramente para fines ilustrativos y de identificación. No hacen referencia a que hayan aprobado este sitio web o su contenido.",
            ],
            email: "contacto@greedy.mx",
          },
          {
            header: "Liberación y limitación de responsabilidad",
            paragraphs: [
              "Este sitio web (incluyendo sin limitación cualquier parte de este, incluso las ligas a las redes sociales de Greedy) contiene únicamente información general de los servicios que ofrecemos y no se provee de ningún tipo de asesoría o servicios profesionales.",
              "A través de este sitio web ponemos a su disposición un formulario de contacto. El llenado de este formato no constituye ningún tipo de relación contractual entre Greedy y la persona usuaria del sitio, este formato es exclusivamente un medio de contacto y no obliga a Greedy a la prestación de ninguno de sus servicios.",
              "Este sitio web es puesto a disposición tal como se puede apreciar, no garantizamos que el sitio web sea seguro, libre de errores, virus o códigos maliciosos, y que cumpla con criterios particulares sobre desempeño y calidad. El uso de este sitio web es bajo su propio riesgo y usted asume toda la responsabilidad y riesgo de pérdida de información derivada de su uso.",
              "Greedy no será responsable por cualquier daño causado de manera directa o indirecta en relación con, o como resultado, del uso de este sitio web, incluso si se tenía conocimiento respecto de la posibilidad de causar tales daños.",
              "Nos reservamos el derecho de suspender, interrumpir o dejar de operar el sitio y los servicios, en cualquier momento.",
            ],
          },
          {
            header: "Ligas a sitios externos",
            paragraphs: [
              "En este sitio web podrá encontrar enlaces que lo pueden dirigir a páginas web, recursos o herramientas de terceros. Nosotros no tenemos ningún control sobre los sitios de terceros (incluyendo aquellos en los que se encuentran las redes sociales de Greedy) en consecuencia no se rigen por nuestros",
              "Términos y Condiciones",
              "ni nuestro",
              "Aviso de Privacidad.",
              "Sin excepción alguna, en caso de que decida visitar estos sitios web, no garantizamos los contenidos ni la seguridad de dichos sitios web, ni de sus recursos o herramientas, así como de los enlaces que contengan.",
              "Tales contenidos, recursos y herramientas no deben entenderse como aprobados por Greedy. Le recomendamos que revise el aviso de privacidad de cada sitio web antes de revelar información personal.",
            ],
          },
          {
            header: "Uso inadecuado del sitio",
            paragraphs: [
              "En Greedy estamos comprometidos a brindar nuestros servicios bajo el mayor profesionalismo y honestidad. Por lo tanto, solicitamos a las personas usuarias de los mismos no realizar un uso inadecuado del sitio que afecte o interfiera con los servicios que ofrecemos. Se considerará como uso inadecuado los siguientes:",
            ],
            list: [
              "Realizar un mal uso del formulario de contacto al enviar información falsa, engañosa o bien, que pueda resultar obscena, abusiva, fraudulenta o difamatoria.",
              "Hacer uso del sitio con fines comerciales o que violen los derechos de propiedad intelectual de Greedy.",
              "Atentar e interferir en el funcionamiento del sitio web a través del envío de un virus o cualquier otro que tenga por objeto dañar al sitio o a sus personas usuarias.",
            ],
            paragraphsAfterList: [
              "El uso de este sitio web está regido por las disposiciones legales aplicables y Greedy tomará las acciones legales correspondientes en caso de verse afectado por el mal uso de su sitio web.",
            ],
          },
          {
            header: "Términos adicionales",
            paragraphs: [
              "Greedy podrá modificar estos términos y condiciones en cualquier momento y de manera unilateral. Dichas modificaciones entrarán en vigor tras su publicación, excepto que se indique de otra manera, y contendrán la fecha de actualización en la parte final de estos términos. Le recomendamos revisar periódicamente esta página web y estar consiente de cualquier revisión de los Términos y condiciones. El continuo uso de este sitio web tras una modificación de sus términos constituye la aceptación de estos.",
              "Al usar este sitio web se compromete a sacar libre de cualquier responsabilidad a Greedy en caso de su uso inadecuado de este sitio web resulte en alguna disputa legal. Para ello, los presentes términos se sujetarán a la legislación aplicable y a los tribunales competentes de la Ciudad de México.",
              "Para cualquier duda o comentario que tenga respecto de nuestros Términos y Condiciones puede hacernos llegar un correo a contacto@greedy.mx o contactarnos en el teléfono y dirección que se encuentra en este sitio web.",
            ],
            lastUpdate: "Última actualización: junio 2025",
          },
        ],
      },
      privacy: {
        title: "Aviso de Privacidad",
        introduction:
          "Greedy está comprometido con la protección de su privacidad y sus datos personales por lo que, en cumplimiento con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares hacemos de su conocimiento lo siguiente:",
        sections: [
          {
            header: "Greedy",
            paragraphs: [
              "En Tecnología e Innovación Greedy S.A. de C.V. somos una empresa de tecnología que ofrece una amplia gama de servicios diseñados para satisfacer las necesidades tecnológicas de sus clientes. Nuestro domicilio se encuentra en Paseo de los Framboyanes 123, Paseos de taxqueña, Coyoacan, 04250, CDMX.",
              "Usted podrá ejercer sus derechos correspondientes a sus datos personales enviando un correo a",
              "contacto@greedy.mx",
            ],
          },
          {
            header: "Finalidad del uso de sus datos personales",
            description:
              "Los datos personales que recabamos los utilizamos para las siguientes finalidades principales que son necesarias para proporcionarle nuestros servicios:",
            list: [
              "Identificarle y ponernos en contacto con usted.",
              "Integrar su expediente como cliente o prospecto de cliente.",
              "Conocer su proyecto o idea de negocio.",
              "Proveerle la información acerca de nuestros servicios.",
              "Proveerle los servicios que contrata con nosotros y cumplir las obligaciones contraídas con usted.",
              "Efectuar gestiones de cobranza y facturación.",
              "Cumplir con la normativa aplicable.",
              "Utilizar tecnologías de rastreo y herramientas de terceros, como Google Ads, para mostrarle publicidad personalizada basada en su comportamiento de navegación, siempre respetando sus derechos ARCO.",
            ],
          },
          {
            header: "Datos personales que utilizamos",
            description:
              "Los datos personales son obtenidos directamente del titular, de instituciones con las que tenemos convenios de colaboración y de terceras personas.",
            list: [
              "Datos personales: aquellos relacionados con su identificación y contacto.",
              "Datos patrimoniales: datos de facturación; los datos requeridos para gestiones de pago y facturación; los datos que se generen por la relación jurídica y; los datos que usted decida proporcionarnos por decisión propia.",
            ],
            note: "Las ideas y proyectos de negocio que nos haga llegar será información de carácter confidencial en tanto no se pacten nuevos términos y, en caso de no concretar una relación contractual podrá solicitar su cancelación de acuerdo con el procedimiento contenido en este aviso.",
          },
          {
            header: "Protección a la privacidad de los menores de edad",
            description:
              "Nuestro sitio web no está diseñado ni está intencionalmente dirigido a menores de 18 años. No ofrecemos ningún servicio ni aceptamos información de cualquier persona menor de edad.",
          },
          {
            header: "Transferencias de sus datos personales y sus finalidades",
            description:
              "Greedy no realiza transferencias de Datos Personales, salvo aquellas previstas en el artículo 37 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares. Sin embargo, en caso de que la relación contractual lo requiera se podrán pactarán nuevos términos en el contrato correspondiente.",
          },
          {
            header: "Medidas de seguridad",
            paragraphs: [
              "Su información personal será resguardada bajo estricta confidencialidad y para prevenir razonablemente su uso o divulgación indebida. Greedy adoptará las medidas administrativas, técnicas y físicas que permitan proteger sus datos personales contra daño, pérdida, alteración, destrucción o el uso, acceso o tratamiento no autorizado.",
              "En Greedy estamos comprometidos con su privacidad y la seguridad de su información. Por lo tanto, tomamos las medidas necesarias para proteger toda su información utilizando tecnología de seguridad y procedimientos de control en el acceso, uso o divulgación de sus datos personales. Lamentablemente, ningún sistema de seguridad o de transmisión de datos, del cual la empresa no tenga control absoluto, puede garantizar ser totalmente seguro.",
            ],
          },
          {
            header: "Derechos que tiene respecto de sus datos personales",
            description:
              "Existen derechos sobre sus datos, denominados como derechos ARCO y son los siguientes:",
            list: [
              "Acceso: derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos y sus condiciones de uso.",
              "Rectificación: derecho a la corrección de sus datos en caso de que estén desactualizados, sean inexactos o incompletos.",
              "Cancelación: derecho a solicitar que eliminemos sus datos de nuestros registros o bases de datos cuando considere que no se está haciendo un uso adecuado de ellos.",
              "Oposición: usted puede oponerse al uso o divulgación de sus datos personales para fines específicos.",
            ],
            note: "Usted puede hacer uso de cualquiera de sus derechos y, además, podrá limitar el uso o divulgación de sus datos personales, podrá en cualquier momento manifestar su negativa a los tratamientos secundarios de sus datos o bien revocar el consentimiento que nos ha otorgado.",
          },
          {
            header: "Mecanismo para ejercer sus derechos ARCO",
            description: [
              "Para ejercer cualquiera de sus derechos, previstos en el apartado anterior, deberá enviar una solicitud al correo ",
              "contacto@greedy.mx",
              ". Dicha solicitud deberá contener lo siguiente:",
            ],
            list: [
              "Nombre del titular de los datos personales.",
              "Correo electrónico para recibir notificaciones y la respuesta a su solicitud.",
              "Copia del documento que acrediten su identidad.",
              "Descripción clara y precisa del (los) derecho(s) que se pretende ejercer.",
              "Cualquier otro elemento o documento que facilite la localización de los datos personales.",
            ],
            paragraphs: [
              "En caso de que la solicitud no satisfaga alguno de los requisitos señalados anteriormente, Greedy lo contactará en los siguientes 5 días hábiles después de haber recibido la solicitud. Mediante la misma vía usted podrá aportar los elementos o documentos necesarios para que la solicitud proceda.",
              "Los tiempos de respuesta al ejercicio de sus derechos son los que dispone la Ley Federal de Protección de Datos Personales en Posesión de Particulares y su Reglamento.",
            ],
          },
          {
            header:
              "El uso de tecnologías de rastreo en nuestro portal de internet",
            paragraphs: [
              "Este sitio recibe información estándar de registro, incluyendo su dirección IP, tipo de navegador, el idioma, tiempos de acceso y direcciones de sitios web.",
              "Para administrar y facilitar una mejor navegación en nuestro sitio web, nosotros o nuestros proveedores de servicios podemos utilizar cookies (pequeños archivos de texto que se almacenan en el navegador del usuario) o web beacons (imágenes electrónicas que permiten contar los visitantes que han accedido a una página en particular y acceder a determinadas cookies) para recabar datos agregados.",
              "En particular, nuestro sitio puede utilizar cookies de publicidad de Google Ads y sus socios, que permiten mostrarle anuncios relevantes basados en sus intereses y visitas anteriores a otros sitios web. Puede conocer más sobre cómo Google utiliza estas cookies en:",
              "https://policies.google.com/technologies/ads",
              ", y gestionar sus preferencias de anuncios en:",
              "https://adssettings.google.com",
            ],
          },
          {
            header:
              "Modificaciones y mecanismos para conocer el aviso de privacidad",
            paragraphs: [
              "Nuestro aviso de privacidad lo podrá encontrar en nuestro sitio web",
              "Greedy podrá modificar este aviso de privacidad en cualquier momento. Dichas modificaciones entrarán en vigor tras su publicación, excepto que se indique de otra manera, y contendrán la fecha de actualización en la parte final del aviso. Le recomendamos revisar periódicamente esta página web y estar consiente de cualquier actualización a este Aviso de Privacidad.",
              "Si aún tiene alguna pregunta o inquietud con respecto a este sitio web, su contenido o el uso que le damos a sus datos personales, puede hacernos llegar un correo a",
              "contacto@greedy.mx",
              "o contactarnos en el teléfono y dirección que se encuentra en este sitio web.",
            ],
            lastUpdate: "Última actualización: junio 2025",
          },
        ],
      },
      cookies: {
        title: "Política de Cookies",
        introduction: [
          "En",
          "Tecnología e Innovación Greedy S.A. de C.V. ",
          "(“Greedy”), utilizamos cookies y tecnologías similares en nuestro sitio web",
          "https://greedy.mx",
          "con el fin de brindar una mejor experiencia de navegación, personalizar el contenido, ofrecer funcionalidades en redes sociales y analizar el tráfico del sitio. A través de la presente Política de Cookies le informamos sobre el uso que hacemos de dichas tecnologías, los datos que recopilamos y cómo puede gestionarlas.",
        ],
        sections: [
          {
            header: "¿Qué son las cookies?",
            paragraphs: [
              "Las",
              "cookies ",
              "son pequeños archivos de texto que se almacenan en su dispositivo (computadora, tableta, teléfono móvil, etc.) cuando visita un sitio web. Estas permiten recordar su actividad en línea, como sus preferencias de navegación o la información de inicio de sesión.",
              "También utilizamos",
              "web beacons, pixels",
              " u otras tecnologías similares que nos permiten recolectar datos al momento en que usted interactúa con nuestro sitio.",
            ],
          },
          {
            header: "Tipos de cookies que utilizamos",
            paragraphs: [
              "El sitio web de Greedy utiliza los siguientes tipos de cookies:",
            ],
            list: [
              {
                number: "1.",
                boldText: "Cookies estrictamente necesarias:",
                text: "Son esenciales para el funcionamiento del sitio web. Permiten la navegación y el uso de sus funciones básicas, como el acceso seguro a áreas protegidas.",
              },
              {
                number: "2.",
                boldText: "Cookies de rendimiento o analíticas:",
                text: "Correo electrónico para recibir notificaciones y la respuesta a su solicitud.",
              },
              {
                number: "3.",
                boldText: "Cookies de funcionalidad:",
                text: "Copia del documento que acrediten su identidad.",
              },
              {
                number: "4.",
                boldText: "Cookies de terceros:",
                text: "Descripción clara y precisa del (los) derecho(s) que se pretende ejercer.",
              },
            ],
          },
          {
            header: "Finalidades del uso de cookies",
            paragraphs: [
              "Las cookies utilizadas por Greedy tienen las siguientes finalidades:",
            ],
            dotList: [
              "Son esenciales para el funcionamiento del sitio web. Permiten la navegación y el uso de sus funciones básicas, como el acceso seguro a áreas protegidas.",
              "Correo electrónico para recibir notificaciones y la respuesta a su solicitud.",
              "Copia del documento que acrediten su identidad.",
              "Descripción clara y precisa del (los) derecho(s) que se pretende ejercer.",
            ],
          },
          {
            header: "¿Cómo puede gestionar o desactivar las cookies?",
            paragraphs: [
              "Usted puede permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones del navegador que utilice. A continuación, se indican enlaces a las instrucciones de los navegadores más comunes:",
            ],
            links: [
              {
                text: "Google Chrome",
                url: "https://privacysandbox.google.com/cookies/basics/cookie-blocking?hl=es-419#:~:text=En%20Chrome%2C%20puedes%20bloquear%20las,selecciona%20Bloquear%20cookies%20de%20terceros.",
              },
              {
                text: "Mozilla Firefox",
                url: "https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias",
              },
              {
                text: "Safari",
                url: "https://support.apple.com/es-mx/guide/safari/sfri11471/mac",
              },
              {
                text: "Microsoft Edge",
                url: "https://support.microsoft.com/es-es/windows/administrar-cookies-en-microsoft-edge-ver-permitir-bloquear-eliminar-y-usar-168dab11-0753-043d-7c16-ede5947fc64d",
              },
            ],
            note: "Tenga en cuenta que la desactivación o eliminación de cookies puede afectar el correcto funcionamiento de algunas funciones del sitio web.",
          },
          {
            header: "Consentimiento",
            paragraphs: [
              "Al continuar navegando en nuestro sitio web, usted consiente expresamente el uso de cookies de conformidad con los términos de esta Política. En caso de que no esté de acuerdo, le recomendamos ajustar la configuración de su navegador o abstenerse de utilizar nuestro sitio.",
            ],
          },
          {
            header: "Modificaciones a esta Política de Cookies",
            paragraphs: [
              "Greedy podrá modificar en cualquier momento la presente Política de Cookies para adaptarla a cambios legislativos, reglamentarios o a las instrucciones de las autoridades competentes. Las modificaciones entrarán en vigor en cuanto se publiquen en esta misma sección del sitio web.",
              "Le recomendamos revisar periódicamente esta política para estar informado sobre cómo y para qué usamos las cookies.",
            ],
          },
          {
            header: "Contacto",
            paragraphs: [
              "Si tiene alguna duda, comentario o desea ejercer sus derechos en relación con el uso de cookies, puede enviarnos un correo a:",
            ],
            contact: {
              email: "contacto@greedy.mx",
              address:
                "Paseo de los Framboyanes 123, Paseos de Taxqueña, Coyoacán, 04250, CDMX.",
            },
            lastUpdate: "Última actualización: junio 2025",
          },
        ],
      },
    },
    footer: {
      terms: "Términos y Condiciones",
      privacy: "Aviso de Privacidad",
      cookies: "Política de Cookies",
    },
  },
  // ENGLISH
  {
    header: [
      { service: "SERVICES", path: "services" },
      { service: "INDUSTRIES", path: "industries" },
      { service: "PORTFOLIO", path: "portfolio" },
      { service: "ABOUT US", path: "about-us" },
      { service: "CONTACT", path: "contact" },
    ],
    mainPage: {
      sectionOne: {
        title: "The technology partner you were",
        titleSecondRow: "looking for",
      },
    },
    ourServices: {
      title: "Our Services",
      description:
        "We have a wide range of services designed to meet the technological needs of your company, focusing on innovative, efficient, and tailor-made solutions that make us your ideal technology partner.",
      tecnologyCards: [
        // webApps
        {
          icon: CardIconWeb,
          title: "Web Design and Development",
          description:
            "We are experts in creating intuitive and responsive platforms, transforming your ideas into impactful and efficient websites.",
          tecnologies: [
            { name: "AngularJS", icon: TL_Angular },
            { name: "ReactJS", icon: TL_React },
            { name: "NodeJS", icon: TL_Node },
          ],
        },
        // movile
        {
          icon: CardIconApp,
          title: "Mobile Applications",
          description:
            "We develop custom mobile applications, combining innovation and functionality to ensure an exceptional user experience.",
          tecnologies: [
            { name: "Kotlin", icon: TL_Kotlin },
            { name: "Android", icon: TL_Android },
            { name: "iOS", icon: TL_IOS },
            { name: "Swift", icon: TL_Swift },
          ],
        },
        // iot
        {
          icon: CardIconIoT,
          title: "IoT | Internet of Things",
          description:
            "We lead the IoT revolution, efficiently and securely integrating smart devices that improve daily life and business.",
          tecnologies: [
            { name: "Python", icon: TL_Python },
            { name: "Javascript", icon: TL_JS },
            { name: "C#", icon: TL_CSharp },
          ],
        },
        // automation
        {
          icon: CardIconAuto,
          title: "Process Automation",
          description:
            "We optimize your business operations, reducing time and maximizing results. Boost your productivity with our strategies and solutions.",
          tecnologies: [
            { name: "Javascript", icon: TL_JS },
            { name: "UiPath", icon: TL_UiPath },
            { name: "Blue Prism", icon: TL_BluePrism },
            { name: "Automation Anywhere", icon: TL_AutoAny },
          ],
        },
        // cloudServices
        {
          icon: CardIconCloud,
          title: "Cloud Architecture and Services",
          description:
            "We offer secure, scalable cloud solutions tailored to your specific needs to drive your company's digital transformation.",
          tecnologies: [
            { name: "Amazon Web Services", icon: TL_AWS },
            { name: "Microsoft Azure", icon: TL_Azure },
            { name: "Google Cloud", icon: TL_GCloud },
          ],
        },
        // consultancy
        {
          icon: CardIconConsult,
          title: "Technology Consulting",
          description:
            "Our team of experts provides strategic technology consulting, helping you navigate the changing digital landscape with confidence.",
          tecnologies: [],
        },
      ],
    },
    Industries: {
      title: "Multiple Industries",
      description:
        "We have had the opportunity to actively participate in various projects spanning a wide range of industries and sectors at different technological stages.",
      typeOfIndustries: [
        {
          icon: IconEnergy,
          title: "Energy",
        },
        {
          icon: IconTelecomm,
          title: "Telecommunications",
        },
        {
          icon: IconRetail,
          title: "Retail",
        },
        {
          icon: IconMassiveGoods,
          title: "Consumer Goods",
        },
        {
          icon: IconConstruction,
          title: "Construction",
        },
        {
          icon: IconBank,
          title: "Banking",
        },
        {
          icon: IconFinance,
          title: "Finance and Accounting",
        },
        {
          icon: IconStockMarket,
          title: "Capital Markets",
        },
        {
          icon: IconInsurance,
          title: "Insurance",
        },
        {
          icon: IconRealState,
          title: "Real Estate",
        },
        {
          icon: IconConsulting,
          title: "Consulting and Advisory",
        },
        {
          icon: IconHS,
          title: "Hardware and Software",
        },
      ],
    },
    portfolio: {
      title: "Success Stories",
      description:
        "Like our clients, we have a vehement desire to make great technological projects a reality. Explore how we have collaborated with industry leaders to create impactful and efficient solutions.",
      filterButton: "Search",
      labelFilterIndustry: "Industry",
      inputLabelIndustry: "Select an industry",
      labelFilterCompany: "Companies",
      inputFilterCompany: "Select a company",
      titleProject: "Projects of",
      projectInformationCard: {
        client: "Client",
        Industry: "Industry",
        Service: "Services",
      },
    },
    aboutUs: {
      title: "Why GREEDY?",
      description:
        "We are optimists by nature, so we firmly believe in the good side of things. We know that our clients have an immoderate eagerness and vehement desire to turn their ideas and technological projects into reality, which is why they deserve a technology partner who has the same eagerness and desire to meet their expectations.",
    },
    contact: {
      title: "Let's be Partners!",
      description:
        "We are very excited to team up with you and turn your business vision into reality. You can contact us through the following form or with the following details:",
      nameField: "Name",
      emailField: "Email",
      companyField: "Company",
      phoneField: "Phone",
      messageFiled: "Tell us about your idea/project",
      emailInfo: "Email:",
      phoneInfo: "Contact Phone:",
      addressInfo: "Address:",
      ButtonSend: "Send",
    },
    legal: {
      terms: {
        title: "Terms and Conditions",
        description: [
          "By browsing on",
          "https://greedy.mx/",
          "you are consenting to its terms of use. If you do not agree with them, you should refrain from using this site.",
        ],
        sections: [
          {
            header: "Use and Content Restrictions",
            paragraphs: [
              "The purpose of this site is to introduce Greedy and the services it offers. Additionally, we provide a contact form to get to know you and your business vision, with the goal of becoming partners and working together on your technological ideas and projects.",
              "Unless otherwise indicated, you are authorized to view, copy, print, and distribute the contents of this website, under the following conditions:",
            ],
            list: [
              "The use must be for legal and legitimate purposes in accordance with these terms and applicable regulations.",
              "Such use must be exclusively for informational and non-commercial purposes.",
              "The content must not be modified.",
              "Any copy of the content you make must attribute the corresponding copyrights or other attribution associated with it.",
            ],
            paragraphsAfterList: [
              "You are not authorized to copy or use any software, process, or technology incorporated or described in this website.",
              "You must comply with all applicable laws regarding access to and use of this website.",
            ],
          },
          {
            header: "Privacy Policy",
            paragraphs: [
              "Greedy is committed to protecting your personal data. Therefore, we provide our Privacy Notice and our Cookies Policy, both available on this website. These documents explain our use of tracking technologies like cookies, including third-party tools such as Google Ads, which you may find on this website. We inform you that we may use your personal data and information under the terms indicated. By using this site, you accept the terms of our Privacy Notice, including the obligations contained therein.",
            ],
          },
          {
            header: "Confidentiality",
            paragraphs: [
              "The content of this website is the property of Greedy, and we reserve all rights not expressly granted in these terms and conditions of use. You may not use the Greedy name, logo, brand, or distinctive signs in any of your own or promotional materials, whether in written, oral, electronic, visual, or any other form, unless expressly permitted.",
              "To request such authorization in writing, please contact us at the email",
              "References to third-party trademarks on this website are for illustrative and identification purposes only. They do not imply that they have endorsed this website or its content.",
            ],
            email: "contacto@greedy.mx",
          },
          {
            header: "Disclaimer and Limitation of Liability",
            paragraphs: [
              "This website (including, without limitation, any part of it, including links to Greedy's social media) contains only general information about the services we offer and does not provide any kind of professional advice or services.",
              "Through this website, we provide a contact form. Filling out this form does not constitute any type of contractual relationship between Greedy and the user of the site. This form is exclusively a means of contact and does not obligate Greedy to provide any of its services.",
              "This website is provided 'as is'. We do not guarantee that the website will be secure, error-free, free of viruses or malicious codes, or that it will meet particular criteria of performance or quality. Your use of this website is at your own risk, and you assume all responsibility and risk of loss of information resulting from its use.",
              "Greedy will not be liable for any direct or indirect damages related to or resulting from the use of this website, heven if we were aware of the possibility of such damages.",
              "We reserve the right to suspend, interrupt, or cease operation of the site and services at any time.",
            ],
          },
          {
            header: "Links to External Sites",
            paragraphs: [
              "On this website, you may find links that can direct you to third-party web pages, resources, or tools. We have no control over third-party sites (including those where Greedy's social networks are located); consequently, they are not governed by our",
              "Terms and Conditions",
              "or our",
              "Privacy Notice.",
              "Without exception, if you decide to visit these websites, we do not guarantee the content or security of such websites, their resources, or tools, nor any links they may contain.",
              "Such content, resources, and tools should not be understood as endorsed by Greedy. We recommend that you review the privacy notice of each website before disclosing personal information.",
            ],
          },
          {
            header: "Improper Use of the Site",
            paragraphs: [
              "At Greedy, we are committed to providing our services with the utmost professionalism and honesty. Therefore, we ask users not to make improper use of the site that affects or interferes with the services we offer. The following will be considered improper use:",
            ],
            list: [
              "Misusing the contact form by sending false, misleading, or information that may be obscene, abusive, fraudulent, or defamatory.",
              "Using the site for commercial purposes or in a way that violates Greedy's intellectual property rights.",
              "Attempting to interfere with the operation of the website by sending a virus or any other item intended to damage the site or its users.",
            ],
            paragraphsAfterList: [
              "The use of this website is governed by applicable legal provisions, and Greedy will take appropriate legal action if it is affected by the misuse of its website.",
            ],
          },
          {
            header: "Additional Terms",
            paragraphs: [
              "Greedy may modify these terms and conditions at any time and unilaterally. Such modifications will take effect upon their publication, unless otherwise indicated, and will include the update date at the end of these terms. We recommend that you periodically review this web page to be aware of any revisions to the Terms and Conditions. Your continued use of this website after a modification of its terms constitutes your acceptance of them.",
              "By using this website, you agree to hold Greedy harmless from any liability in the event that your improper use of this website results in any legal dispute. For this purpose, these terms will be subject to the applicable legislation and the competent courts of Mexico City.",
              "For any questions or comments regarding our Terms and Conditions, you can send us an email at contacto@greedy.mx or contact us at the phone number and address found on this website.",
            ],
            lastUpdate: "Last updated: June 2025",
          },
        ],
      },

      privacy: {
        title: "Privacy Notice",
        introduction:
          "Greedy is committed to protecting your privacy and personal data. Therefore, in compliance with the Federal Law on Protection of Personal Data Held by Private Parties, we inform you of the following:",
        sections: [
          {
            header: "Greedy",
            paragraphs: [
              "At Tecnología e Innovación Greedy S.A. de C.V., we are a technology company that offers a wide range of services designed to meet the technological needs of our clients. Our address is Paseo de los Framboyanes 123, Paseos de Taxqueña, Coyoacán, 04250, CDMX.",
              "You may exercise your rights regarding your personal data by sending an email to",
              "contacto@greedy.mx",
            ],
          },
          {
            header: "Purpose of Using Your Personal Data",
            description:
              "The personal data we collect is used for the following main purposes, which are necessary to provide you with our services:",
            list: [
              "To identify you and contact you.",
              "To create your file as a client or prospective client.",
              "To understand your project or business idea.",
              "To provide you with information about our services.",
              "To provide the services you contract with us and fulfill the obligations agreed upon with you.",
              "To carry out collection and billing procedures.",
              "To comply with applicable regulations.",
              "To use tracking technologies and third-party tools, such as Google Ads, to show you personalized advertising based on your browsing behavior, always respecting your ARCO rights.",
            ],
          },
          {
            header: "Personal Data We Use",
            description:
              "Personal data is obtained directly from the owner, from institutions with which we have collaboration agreements, and from third parties.",
            list: [
              "Personal data: those related to your identification and contact.",
              "Financial data: billing data; data required for payment and billing management; data generated by the legal relationship; and data you choose to provide us at your own discretion.",
            ],
            note: "Business ideas and projects you send us will be treated as confidential information as long as no new terms are agreed upon. If a contractual relationship is not established, you may request its cancellation according to the procedure contained in this notice.",
          },
          {
            header: "Protection of Minors' Privacy",
            description:
              "Our website is not designed for or intentionally directed at minors under 18 years of age. We do not offer any services to or accept information from anyone under age.",
          },
          {
            header: "Transfers of Your Personal Data and Their Purposes",
            description:
              "Greedy does not transfer Personal Data, except as provided in Article 37 of the Federal Law on Protection of Personal Data Held by Private Parties. However, if the contractual relationship requires it, new terms may be agreed upon in the corresponding contract.",
          },
          {
            header: "Security Measures",
            paragraphs: [
              "Your personal information will be kept under strict confidentiality and to reasonably prevent its improper use or disclosure. Greedy will adopt administrative, technical, and physical measures to protect your personal data against damage, loss, alteration, destruction, or unauthorized use, access, or processing.",
              "At Greedy, we are committed to your privacy and the security of your information. Therefore, we take the necessary measures to protect all your information using security technology and control procedures for the access, use, or disclosure of your personal data. Unfortunately, no security system or data transmission system over which the company does not have absolute control can be guaranteed to be completely secure.",
            ],
          },
          {
            header: "Your Rights Regarding Your Personal Data",
            description:
              "You have rights over your data, known as ARCO rights, which are as follows:",
            list: [
              "Access: the right to know what personal data we have about you, what we use it for, and the conditions of its use.",
              "Rectification: the right to correct your data if it is outdated, inaccurate, or incomplete.",
              "Cancellation: the right to request that we delete your data from our records or databases when you consider that it is not being used properly.",
              "Opposition: you can object to the use or disclosure of your personal data for specific purposes.",
            ],
            note: "You can exercise any of your rights and, in addition, you can limit the use or disclosure of your personal data. You may at any time express your refusal for secondary processing of your data or revoke the consent you have given us.",
          },
          {
            header: "Mechanism to Exercise Your ARCO Rights",
            description: [
              "To exercise any of your rights, as provided in the previous section, you must send a request to the email ",
              "contacto@greedy.mx",
              ". This request must contain the following:",
            ],
            list: [
              "Name of the personal data owner.",
              "Email address to receive notifications and the response to your request.",
              "A copy of the document that proves your identity.",
              "A clear and precise description of the right(s) you wish to exercise.",
              "Any other element or document that facilitates the location of the personal data.",
            ],
            paragraphs: [
              "If the request does not meet any of the requirements mentioned above, Greedy will contact you within the next 5 business days after receiving the request. Through the same channel, you can provide the necessary elements or documents for the request to proceed.",
              "The response times for exercising your rights are those established by the Federal Law on Protection of Personal Data Held by Private Parties and its Regulations.",
            ],
          },
          {
            header: "The Use of Tracking Technologies on Our Website",
            paragraphs: [
              "This site receives standard log information, including your IP address, browser type, language, access times, and website addresses.",
              "To manage and facilitate better navigation on our website, we or our service providers may use cookies (small text files stored in the user's browser) or web beacons (electronic images that allow us to count visitors who have accessed a particular page and access certain cookies) to collect aggregate data.",
              "In particular, our site may use advertising cookies from Google Ads and its partners, which allow us to show you relevant ads based on your interests and previous visits to other websites. You can learn more about how Google uses these cookies at:",
              "https://policies.google.com/technologies/ads",
              ", and manage your ad preferences at:",
              "https://adssettings.google.com",
            ],
          },
          {
            header: "Modifications and Mechanisms to Know the Privacy Notice",
            paragraphs: [
              "You can find our privacy notice on our website",
              "Greedy may modify this privacy notice at any time. Such modifications will take effect upon their publication, unless otherwise indicated, and will include the update date at the end of the notice. We recommend that you periodically review this web page to be aware of any updates to this Privacy Notice.",
              "If you still have any questions or concerns regarding this website, its content, or our use of your personal data, you can send us an email at",
              "contacto@greedy.mx",
              "or contact us at the phone number and address found on this website.",
            ],
            lastUpdate: "Last updated: June 2025",
          },
        ],
      },
      cookies: {
        title: "Cookies Policy",
        introduction: [
          "At",
          "Tecnología e Innovación Greedy S.A. de C.V. ",
          "(“Greedy”), we use cookies and similar technologies on our website",
          "https://greedy.mx",
          "to provide a better browsing experience, personalize content, offer social media features, and analyze site traffic. Through this Cookies Policy, we inform you about our use of these technologies, the data we collect, and how you can manage them.",
        ],
        sections: [
          {
            header: "What are cookies?",
            paragraphs: [
              "The",
              "Cookies",
              "are small text files that are stored on your device (computer, tablet, mobile phone, etc.) when you visit a website. They allow the site to remember your online activity, such as your browsing preferences or login information.",
              "We also use ",
              "web beacons, pixels,",
              " or other similar technologies that allow us to collect data when you interact with our site.",
            ],
          },
          {
            header: "Types of cookies we use",
            paragraphs: [
              "The Greedy website uses the following types of cookies:",
            ],
            list: [
              {
                number: "1.",
                boldText: "Strictly Necessary Cookies:",
                text: "These are essential for the website to function. They enable navigation and the use of its basic features, such as secure access to protected areas.",
              },
              {
                number: "2.",
                boldText: "Performance or Analytical Cookies:",
                text: "These collect information about how you use our website, such as which pages you visit and if you experience any errors. This data helps us improve the site's performance.",
              },
              {
                number: "3.",
                boldText: "Functionality Cookies:",
                text: "These are used to remember choices you make (such as your user name, language, or the region you are in) and provide enhanced, more personal features.",
              },
              {
                number: "4.",
                boldText: "Third-Party Cookies:",
                text: "These are set by a domain other than the one you are visiting. We use third-party cookies for our advertising and marketing efforts, such as Google Ads.",
              },
            ],
          },
          {
            header: "Purposes of Using Cookies",
            paragraphs: [
              "The cookies used by Greedy have the following purposes:",
            ],
            dotList: [
              "To ensure the proper functioning of the website, allowing navigation and use of its basic features.",
              "To analyze user behavior to improve our services and user experience.",
              "To remember your preferences and settings to provide a personalized experience.",
              "To deliver personalized advertising relevant to your interests through third-party services like Google Ads.",
            ],
          },
          {
            header: "How can you manage or disable cookies?",
            paragraphs: [
              "You can allow, block, or delete the cookies installed on your computer by configuring the options of the browser you use. Below are links to the instructions for the most common browsers:",
            ],
            links: [
              {
                text: "Google Chrome",
                url: "https://support.google.com/chrome/answer/95647",
              },
              {
                text: "Mozilla Firefox",
                url: "https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences",
              },
              {
                text: "Safari",
                url: "https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac",
              },
              {
                text: "Microsoft Edge",
                url: "https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09",
              },
            ],
            note: "Please note that disabling or deleting cookies may affect the proper functioning of some features of the website.",
          },
          {
            header: "Consent",
            paragraphs: [
              "By continuing to browse our website, you expressly consent to the use of cookies in accordance with the terms of this Policy. If you do not agree, we recommend that you adjust your browser settings or refrain from using our site.",
            ],
          },
          {
            header: "Changes to this Cookies Policy",
            paragraphs: [
              "Greedy may modify this Cookies Policy at any time to adapt it to legislative or regulatory changes or to the instructions of competent authorities. The modifications will take effect as soon as they are published in this same section of the website.",
              "We recommend that you periodically review this policy to stay informed about how and why we use cookies.",
            ],
          },
          {
            header: "Contact",
            paragraphs: [
              "If you have any questions, comments, or wish to exercise your rights regarding the use of cookies, you can send us an email at:",
            ],
            contact: {
              email: "contacto@greedy.mx",
              address:
                "Paseo de los Framboyanes 123, Paseos de Taxqueña, Coyoacán, 04250, CDMX.",
            },
            lastUpdate: "Last updated: June 2025",
          },
        ],
      },
    },
    footer: {
      terms: "Terms and Conditions",
      privacy: "Privacy Notice",
      cookies: "Cookies Policy",
    },
  },
  // If you add another language, you need to also add its flag to the languageOptions variable.
];

export const languageOptions = [
  { icon: mexicoFlag, country: "México" },
  { icon: USAFlag, country: "USA" },
];
